import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchGetProduct } from "./digitalSignatureAPI";

export const getProducts = createAsyncThunk(
	'digitalSignature/getProduct',
	async (pid) => {
		const response = await fetchGetProduct(pid)
		return response;
	}
)

const digitalSignatureSlice = createSlice({
	name: "digitalSignature",
	initialState: {
		status: "",
		error: "",
		price: "",
		name: "",
	},
	extraReducers: (builder) => {
		builder
			.addCase(getProducts.pending, (state) => {
				state.status = 'loading'
			})
			.addCase(getProducts.fulfilled, (state, action) => {
				const resData = action.payload.products.product
				state.status = 'fulfilled'
				if (resData[0].pid === 81) {
					state.price = resData[0].pricing.IDR;
					state.name = resData[0].name;
				}
			})
			.addCase(getProducts.rejected, (state, action) => {
				state.status = 'error'
				state.error = action.error.message
			})
	},
})

export default digitalSignatureSlice.reducer;